/* eslint-disable react/require-default-props */
import React from 'react';
import { Container } from './styles';

interface AiManagementSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const AiManagementSearchInput: React.FC<AiManagementSearchInputProps> = ({
  value,
  onChange,
  placeholder = 'Buscar por edital ou palavra-chave',
  className = '',
}) => (
  <Container
    className={`d-flex align-items-center bg-white border rounded px-2 ${
      value.trim() ? 'border-primary' : ''
    } ${className}`}
  >
    <i className="material-icons text-secondary mr-2">search</i>
    <input
      type="text"
      className="search-input form-control h-100 border-0 bg-transparent shadow-none px-0 flex-grow-1"
      placeholder={placeholder}
      aria-label={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    />
    {value && (
      <button
        type="button"
        className="btn btn-link btn-sm p-0 ml-2 flex-shrink-0"
        onClick={() => onChange('')}
      >
        Limpar
      </button>
    )}
  </Container>
);

export default AiManagementSearchInput;
